/* istanbul ignore file */
import CreateActivityForm from 'domain/sales/shared/timeline/activity/form/CreateActivityForm';
import UpdateActivityForm from 'domain/sales/shared/timeline/activity/form/UpdateActivityForm';
import ActivityTimelineRecordLayout from 'domain/sales/shared/timeline/activity/ActivityTimelineRecordLayout';
import { UPDATE_CRM_ACTIVITY_PERMISSION } from './crmActivityService';
import { CRM_ACTIVITY_URL_POSTFIX } from './crmActivityConstants';

const useCrmActivityItem = () => ({
  AddForm: CreateActivityForm,
  UpdateForm: UpdateActivityForm,
  isApplicable: (item: { activity: any }) => item.activity,
  source: 'activity',
  urlPostfix: CRM_ACTIVITY_URL_POSTFIX,
  RecordLayout: ActivityTimelineRecordLayout,
  name: 'Activity',
  buttonSize: 'small',
  permissionToCheck: UPDATE_CRM_ACTIVITY_PERMISSION,
});

export default useCrmActivityItem;
